// extracted by mini-css-extract-plugin
export default {"productGrid":"a0-z","centerLink":"b0-z","productSection":"c0-z","item":"d0-z","ctaButton":"e0-z"};